module.exports = __webpack_public_path__ + "img/icon-delete-line.88da1a71.svg";